




























import { Vue, Component, PropSync, Ref, Prop } from 'vue-property-decorator';
import { YorN } from 'ncp-api-supporter';
import ToolTip from '@/pro/components/common/tooltip/ToolTip.vue';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import TextInput from '@/pro/components/common/input/TextInput.vue';
import DateRangePicker from '@/pro/components/common/DateRangePicker.vue';
import { DateRangeOption, ProductDescInfo } from '@/pro/types';
import { RadioBoxGroupOption } from '@/pro/helpers/type';
import { today } from '@/pro/views/contents/product/basic/ProductAdd/ProductAdd';
@Component({
  components: { ToolTip, RadioGroup, TextInput, DateRangePicker },
})
export default class ProductDesc extends Vue {
  @PropSync('productDescInfo', { required: true })
  private productDescInfoSync: ProductDescInfo;

  @PropSync('productDescModel', { required: true })
  private productDescModelSync: string;

  @Prop({ required: true })
  private readonly disabled: boolean;

  private radioOption: RadioBoxGroupOption<YorN> = {
    name: 'productDescYn',
    data: [
      {
        id: 'N',
        name: 'productDescYn',
        value: 'N',
        display: 'PRO_PRODUCT_COMMON_NOT_USE',
      },
      {
        id: 'Y',
        name: 'productDescYn',
        value: 'Y',
        display: 'PRO_PRODUCT_COMMON_USE',
      },
    ],
  };

  @Ref() private readonly productDescRef: TextInput;
  public focus(): void {
    this.productDescRef.focus();
  }

  private exposeDateRangeOption: DateRangeOption = {
    name: 'exposePeriod',
    hasPeriodBtn: false,
    fromRanges: today,
  };

  private onChangedProductDesc(val: string): string {
    // this.productDescInfoSync.text = escapeHtml(val);
    this.productDescInfoSync.text = val;
    return val;
  }

  // private productDesc = '';
  reset(): void {
    this.productDescModelSync = '';
  }
}
